<template>
  <div class="[ mk-orderindex ] row justify-content-center align-items-center mb-3">
    <div class="col col-sm-10 align-self-center">
      <div class="mt-5 mb-4 d-flex align-items-center justify-content-between my-4">
        <h1 class="text-green-primary mb-0">Users</h1>
        <button class="btn-primary-rounded" @click="addCustomerUser">Add User</button>
      </div>

      <div class="card got-card">
        <div class="card-body got-order-card" v-loading="loading">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="text-center">First Name</th>
                <th scope="col" class="text-center">Last Name</th>
                <th scope="col" class="text-center">Email</th>
                <th scope="col" class="text-center">Active</th>
                <th scope="col" class="text-center">Primary</th>
                <th></th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tr v-for="(customerUser, index) in customer_users" :key="index">
              <th>
                <div class="d-flex justify-content-center">
                  <el-input v-model="customerUser.first_name"></el-input>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-center">
                  <el-input v-model="customerUser.last_name"></el-input>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-center">
                  <el-input v-model="customerUser.email"></el-input>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-center">
                  <el-switch v-model="customerUser.active" id="active"></el-switch>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-center">
                  <el-switch v-model="customerUser.is_primary_user" id="is_primary_user"></el-switch>
                </div>
              </th>
              <th class="text-center">
                <el-tooltip class="item" effect="dark" :content="'Send invitation'" placement="left">
                  <a v-if="customerUser.id && customerUser.active" href=""
                    @click="sendInvitation($event, customerUser)">
                    <i class="fas fa-envelope font-20 p-2" aria-hidden="true"></i>
                  </a>
                </el-tooltip>
              </th>
              <td style="width: 180px">
                <button class="btn-primary-outline float-left" @click="onManageCustomerUser(customerUser)">
                  Save
                </button>
                <button class="btn btn-sm btn-danger float-left" @click="onDeleteCustomerUser(customerUser)">
                  Delete
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerUser from "../../models/customer/CustomerUser";
export default {
  props: {
    tab: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      per_page: 7,
      page: 1,
      customer_users: [],
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      new CustomerUser().get().then((res) => {
        this.customer_users = res;
      }).catch((err) => {

      });
    },
    addCustomerUser() {
      this.customer_users.push({
        first_name: "",
        last_name: "",
        email: "",
        active: true,
        is_primary_user: false,
        confirmed: false,
      });
    },
    onManageCustomerUser(passed_user) {
      let user = new CustomerUser(passed_user);
      user
        .save()
        .then((res) => {
          if (!passed_user.id) {
            this.$message({
              type: "success",
              message: "User portal added",
            });
            let index = this.customer_users.indexOf(passed_user);
            this.customer_users.splice(index, 1);
            this.customer_users.push(res);
          } else {
            this.$message({
              type: "success",
              message: "User portal updated",
            });
          }
        })
        .catch((error) => {
          var errorText = "";
          _.forEach(error.response.data.errors, function (value) {
            errorText += " - " + value + "";
          });
          this.$message({
            type: "error",
            message: `Error ${errorText}`,
          });
        });
    },
    onDeleteCustomerUser(passed_user) {
      if (passed_user.id) {
        this.$confirm(
          "Are you sure you want to delete this user?",
          "Warning",
          {
            confirmButtonText: "OK",
            confirmButtonClass: "primary-btn",
            cancelButtonText: "Cancel",
            cancelButtonClass: "secondary-btn",
            type: "warning",
          }
        ).then(() => {
          let index = this.customer_users.indexOf(passed_user);
          let user = new CustomerUser(passed_user);
          user.delete().then((res) => {
            this.$message({
              type: "success",
              message: "User portal was removed",
            });
            this.customer_users.splice(index, 1);
          });
        });
      } else {
        let index = this.customer_users.indexOf(passed_user);
        this.customer_users.splice(index, 1);
      }
    },
    sendInvitation(event, passed_user) {
      event.preventDefault();
      this.loading = true;
      axios
        .put(`/api/v1/customer/customer-users/${passed_user.id}/send`, {
          confirmation_sent: true,
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Email sent",
          });
          this.loading = false;
        })
        .catch((errors) => {
          this.$message.info(
            "Invitation was not sent. Please check email addresses"
          );
          this.loading = false;
        });
    }
  },
};
</script>
